// @flow
import axios from 'lib/defaultClient';
import qs from 'query-string';

export type SearchParams = {
  q: string,
  username?: string,
  page?: number,
  menu: string,
};

export const search = ({ q, username, page, menu }: SearchParams) => {
  const query = qs.stringify({ q, username, page, menu });
  return axios.get(`/search?${query}`);
};

export const autoComplete = ({ q, username, page, menu }: SearchParams) => {
  const query = qs.stringify({ q, username, page, menu });
  return axios.get(`/search/auto-complete?${query}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/search.js